<template>
  <div class="">
    <b-navbar toggleable="md" type="dark" variant="info" class="pt-0 pb-0">
      <div class="container">
        <b-navbar-toggle target="nav_collapse_docentes"></b-navbar-toggle>
        <h1 class="text-center navbar-brand pt-0 pb-0 mb-0">Nuevo Docente</h1>
        <b-collapse is-nav id="nav_collapse_docentes">
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <a  :href="`#/docentes`" class="nav-link" title="Cancelar">Cancelar</a>
          </b-navbar-nav>

        </b-collapse>
      </div>
    </b-navbar>
    <div class="container pt-3 m-auto text-left ">
      
      <form
        autocomplete="off"
        class="form-horizontal"
        @submit.prevent="validateBeforeSubmit"
      >
        <div>
          <InputTextSimple titulo="Primer Nombre" :modelo="docente.primer_nombre" 
            @change="docente.primer_nombre = $event"/>
          <InputTextSimple titulo="Segundo Nombre" :modelo="docente.segundo_nombre" 
            @change="docente.segundo_nombre = $event"/>
          <InputTextSimple titulo="Primer Apellido" :modelo="docente.primer_apellido" 
            @change="docente.primer_apellido = $event"/>
          <InputTextSimple titulo="Segundo Apellido" :modelo="docente.segundo_apellido" 
            @change="docente.segundo_apellido = $event"/>
          <SelectTipoDocumento titulo="Tipo de Documento" :modelo="docente.tipo_documento" 
            @change="docente.tipo_documento=$event"/>
          <InputNumeroDocumento titulo="Número de Documento" :modelo="docente.numero_documento" 
            @change="docente.numero_documento=$event"/>
          <InputEmailSimple titulo="Email" :modelo="docente.email" 
            @change="docente.email=$event"/>
          <InputMovil titulo="Telefono" :modelo="docente.telefono" 
            @change="docente.telefono=$event"/>
            <InputMovil titulo="Movil" :modelo="docente.movil" 
            @change="docente.movil=$event"/>

        </div>
        <button class="btn btn-block btn-danger" type="submit">Crear</button>
      </form>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  
  export default {
    name: 'DocenteNuevo',
    data () {
      return {
          docente : {
            primer_nombre:null,
            segundo_nombre:null,
            primer_apellido:null,
            segundo_apellido:null,
            tipo_documento:null,
            numero_documento:null,
            email:null,
            movil:null,
            telefono:null,
          }
      }
    },
    mounted () {
    },
    methods:{
      ...mapActions({
        crear: 'docentes/crear',
        setWarning: 'setWarning',
        fetchLista: 'docentes/fetchLista',
      }),
      ...mapMutations({
      }),
      validateBeforeSubmit () {
        this.$validator.validateAll().then(result => {
          if ( ! result) {
            //hay errores
          } else {
            this.crear(this.docente).then(()=>{
                this.setWarning('Docente Creado', { root: true }).then(()=>{
                this.fetchLista().then(()=>{
                    this.$router.push('/docentes')
                })
              })
            }).catch(error=>{
              //todo probar si se puede quitar
            })
            
          }
        })
      },

    },
    computed:{
      ...mapState({
        warning: state => state.warning
      }),
    }
  }
</script>

<style scope>
  .perfil_wrapper .container{
      background-color: #fff;
      padding: 15px;
  }
</style>